import { DeliveryOption } from "../types";

/** RadioGroup sentinel value for the manual-entry row (not a delivery option id). */
export const MANUAL_DELIVERY_OPTION_RADIO_VALUE = "manual";

export function findDeliveryOptionById(
  deliveryOptions: DeliveryOption[],
  deliveryOptionId: string | undefined,
): DeliveryOption | undefined {
  if (!deliveryOptionId) return undefined;
  return deliveryOptions.find((opt) => opt._id === deliveryOptionId);
}
